import { render, staticRenderFns } from "./OneSignalNotifications.vue?vue&type=template&id=c5896cf6&"
import script from "./OneSignalNotifications.vue?vue&type=script&lang=js&"
export * from "./OneSignalNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports